import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import { DataTablePaginationProps } from '@/types';
import DataTablePaginationButton from './DataTablePaginationButton';
import { usePaginationHandlers } from '@/hooks/usePaginationHandlers';

function DataTablePagination({ table, currentPage, onPageChange }: DataTablePaginationProps) {
  // Use custom hook for pagination handlers
  const { handlers } = usePaginationHandlers({ table, currentPage, onPageChange });
  const { handleFirstPage, handlePreviousPage, handleNextPage, handleLastPage } = handlers;

  const totalPages = table.getPageCount();
  const canGoPrevious = currentPage ? currentPage > 1 : table.getCanPreviousPage();
  const canGoNext = currentPage ? currentPage < totalPages : table.getCanNextPage();
  // should make currentPage then for all other tables...now it is only for TranscriptsTable
  const currentPageNumber = table.getState().pagination.pageIndex + 1;

  return (
    <div className="flex items-center justify-end py-4">
      {totalPages > 1 && (
        <div className="flex items-center space-x-2">
          <DataTablePaginationButton
            className="hidden p-0 size-6 lg:flex"
            disabled={!canGoPrevious}
            onClick={handleFirstPage}
            srLabel="Go to first page"
          >
            <ChevronsLeft className="size-4" />
          </DataTablePaginationButton>

          <DataTablePaginationButton
            disabled={!canGoPrevious}
            onClick={handlePreviousPage}
            srLabel="Go to previous page"
          >
            <ChevronLeft className="size-4" />
          </DataTablePaginationButton>

          {/* Page numbers */}
          <div className="flex w-[80px] items-center justify-center text-xs font-medium">
            Page {currentPageNumber} of {totalPages}
          </div>

          <DataTablePaginationButton
            disabled={!canGoNext}
            onClick={handleNextPage}
            srLabel="Go to next page"
          >
            <ChevronRight className="size-4" />
          </DataTablePaginationButton>

          <DataTablePaginationButton
            className="hidden p-0 size-6 lg:flex"
            disabled={!canGoNext}
            onClick={handleLastPage}
            srLabel="Go to last page"
          >
            <ChevronsRight className="size-4" />
          </DataTablePaginationButton>
        </div>
      )}
    </div>
  );
}

export default DataTablePagination;
